export class NumberUtils {
	/**
	 * Converte um valor numérico ou string de um formato com vírgula para um formato com ponto.
	 *
	 * Este método recebe um valor que pode ser um número ou uma string contendo uma vírgula
	 * como separador decimal, e converte essa vírgula em um ponto para padronização.
	 *
	 * @param value - O valor a ser convertido, pode ser um número ou uma string.
	 * @returns O valor convertido como número com ponto decimal.
	 *
	 * @example
	 * ```typescript
	 * const result = NumberUtils.convertCommaToDot("1,23");
	 * console.log(result); // Saída: 1.23
	 * ```
	 */
	static convertCommaToDot(value: number | string): number {
		if (value === null || value === undefined || value === '') {
			return NaN;
		}

		return Number(String(value).replace(',', '.'));
	}
}
